<template>
  <div v-if="respond!==null" class="rankwrapper"  >

    <div>
      <div class="title">{{title}}</div>
      <div class="value">{{respond.svalue}}</div>
    </div>

    <div>
      <TrendGoalComponent class="bottomComponent" v-if="trendGoalValue!==null" :value="trendGoalValue"/>
    </div>
  </div>

</template>

<script>

  import TrendGoalComponent from "./TrendGoalComponent";

  export default {
    name: 'RankWidget',

    components: {
      TrendGoalComponent
    },

    props: {
      widgetData: Object
    },

    data() {
      return {
        respond: null,

        trendGoalValue: null,
        title: '',
        value: 0,
      }
    },

    computed: {
      // ...mapGetters(['pages'])
//    ...mapState([])
    },

    methods: {
      requestData(requester) {
        // console.log("Ok RankWidget requesting data: " + this.widgetData.expr);
        // console.log(requester)
        requester.addExpressionRequest(this.dataCallback, this.widgetData.extname, this.widgetData.expr);
      },

      dataCallback(dto) {
        this.respond = dto
        this.title = dto.title;
        this.trendGoalValue = dto.trendGoalValue
      },

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .rankwrapper {
    background-color: white;
    color: black;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

  }

  div.title {
    text-align: center;
    font-size: 200%;
    margin-top: 20px;
  }

  div.value {
    margin-top: 20px;
    text-align: center;
    font-size: 250%;
  }

</style>
